import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useState } from "react";

export default function ConfirmDelete({ open, onClose, deleteFunc }) {
  const [deleting, setDeleting] = useState(false);

  const handleDelete = async () => {
    debugger;
    setDeleting(true);
    const success = await deleteFunc();
    setDeleting(false);
    if (success) onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={() => !deleting && onClose()}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 3 },
      }}
    >
      <DialogTitle>
        <Typography variant="h6" fontWeight={600}>
          Confirm Delete
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to delete this record? This action cannot be
          undone.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button onClick={onClose} disabled={deleting} sx={{ borderRadius: 2 }}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={handleDelete}
          sx={{ borderRadius: 2 }}
          disabled={deleting}
          loading={deleting}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}
